import React from 'react';

export const emptyFilters = {
    selectedContinent: 0,
    selectedCountry: 0,
    selectedRegion: 0,
    selectedProvince: 0,
    hashtagInput: '',
    hashtags: [],
    keyword: ''
};

export function applyProgramFilters(programs, filters, countries, provinces) {
    var { selectedContinent, selectedCountry, selectedRegion, selectedProvince, hashtags, keyword } = filters;

    var countryIdsByContinent = selectedContinent > 0
        ? countries.filter(c => c.continentId === parseInt(selectedContinent)).map(c => c.id)
        : null;

    var provById = {};
    (provinces || []).forEach(p => { provById[p.id] = p; });

    var tagList = (hashtags || []).map(t => t.toLowerCase().replace(/^#/, ''));
    var kw = (keyword || '').trim().toLowerCase();

    return programs.filter(p => {
        var pCountryIds = p.countryIds || [];
        var pProvinceIds = p.provinceIds || [];
        var pHashtags = (p.hashtags || []).map(t => t.toLowerCase().replace(/^#/, ''));

        if (countryIdsByContinent && !pCountryIds.some(cid => countryIdsByContinent.includes(cid))) return false;
        if (selectedCountry > 0 && !pCountryIds.includes(parseInt(selectedCountry))) return false;
        if (selectedRegion > 0) {
            var rid = parseInt(selectedRegion);
            if (!pProvinceIds.some(pid => { var pr = provById[pid]; return pr && pr.regionId === rid; })) return false;
        }
        if (selectedProvince > 0 && !pProvinceIds.includes(parseInt(selectedProvince))) return false;
        if (tagList.length > 0 && !tagList.some(t => pHashtags.some(h => h.includes(t)))) return false;
        if (kw) {
            var haystack = ((p.code||'') + ' ' + (p.name||'') + ' ' + (p.destinations||'')).toLowerCase();
            if (!haystack.includes(kw)) return false;
        }
        return true;
    });
}

export function ProgramFilters({ filters, onChange, continents, countries, regions, provinces }) {
    var { selectedContinent, selectedCountry, selectedRegion, selectedProvince, hashtagInput, hashtags, keyword } = filters;

    var countryOptions = selectedContinent > 0
        ? countries.filter(c => c.continentId === parseInt(selectedContinent))
        : [];
    var regionOptions = selectedCountry > 0
        ? (regions || []).filter(r => r.countryId === parseInt(selectedCountry))
        : [];
    var provinceOptions = selectedRegion > 0
        ? (provinces || []).filter(p => p.regionId === parseInt(selectedRegion))
        : selectedCountry > 0
            ? (provinces || []).filter(p => p.countryId === parseInt(selectedCountry))
            : [];

    var set = (patch) => onChange({ ...filters, ...patch });

    var addHashtag = () => {
        var tag = (hashtagInput || '').trim().replace(/^#/, '');
        if (!tag) return;
        if ((hashtags || []).some(h => h.toLowerCase() === tag.toLowerCase())) {
            set({ hashtagInput: '' });
            return;
        }
        set({ hashtags: [...(hashtags||[]), tag], hashtagInput: '' });
    };

    var removeHashtag = (idx) => {
        var arr = [...(hashtags||[])];
        arr.splice(idx, 1);
        set({ hashtags: arr });
    };

    var clearFilters = () => onChange({ ...emptyFilters });

    return (
        <>
            <style>{`
                .search-field label {
                    display: flex; align-items: center; gap: 6px;
                    font-size: 13px; font-weight: 600; color: #555;
                    margin-bottom: 6px;
                }
                .search-field label i { color: #dc3545; font-size: 12px; width: 14px; text-align: center; }
                .search-field .form-control, .search-field .form-select {
                    border: 1.5px solid #e5e5e5; border-radius: 8px;
                    padding: 8px 12px; font-size: 14px; height: 40px;
                    background: #fafafa; transition: all 0.15s;
                    width: 100%;
                }
                .search-field .input-group { width: 100%; }
                .search-field .form-control:focus, .search-field .form-select:focus {
                    border-color: #dc3545; background: #fff;
                    box-shadow: 0 0 0 3px rgba(220,53,69,0.12);
                }
                .search-field .form-select:disabled, .search-field .form-control:disabled {
                    background: #f0f0f0; color: #aaa; cursor: not-allowed;
                }
                .search-field .input-group { flex-wrap: nowrap; }
                .search-field .input-group-text { border: 1.5px solid #e5e5e5; border-right: none; background: #fafafa; border-radius: 8px 0 0 8px; color: #aaa; white-space: nowrap; }
                .search-field .input-group .form-control { border-left: none; border-radius: 0; }
                .search-field .input-group .form-control:last-child { border-radius: 0 8px 8px 0; }
                .search-field .input-group .btn:last-child { border-radius: 0 8px 8px 0 !important; }
            `}</style>
            <div style={{ background:'#fff', borderRadius:12, padding:'22px 26px', boxShadow:'0 4px 20px rgba(0,0,0,0.08)', marginBottom:20 }}>
                <div className="search-field">
                    <div style={{ fontSize:12, fontWeight:700, color:'#888', letterSpacing:1, textTransform:'uppercase', marginBottom:10 }}>
                        <i className="fas fa-map-marked-alt" style={{ color:'#dc3545', marginRight:6 }}></i> ตำแหน่งที่ตั้ง
                    </div>
                    <div className="row g-3">
                        <div className="col-md-3 col-sm-6">
                            <label><i className="fas fa-globe-asia"></i> ทวีป</label>
                            <select className="form-select w-100" value={selectedContinent}
                                onChange={e => set({ selectedContinent: e.target.value, selectedCountry: 0, selectedRegion: 0, selectedProvince: 0 })}>
                                <option value="0">-- ทั้งหมด --</option>
                                {continents.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <label><i className="fas fa-flag"></i> ประเทศ</label>
                            <select className="form-select w-100" value={selectedCountry}
                                disabled={selectedContinent == 0}
                                onChange={e => set({ selectedCountry: e.target.value, selectedRegion: 0, selectedProvince: 0 })}>
                                <option value="0">{selectedContinent == 0 ? '— เลือกทวีปก่อน —' : '-- ทั้งหมด --'}</option>
                                {countryOptions.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <label><i className="fas fa-compass"></i> ภูมิภาค</label>
                            <select className="form-select w-100" value={selectedRegion}
                                disabled={selectedCountry == 0}
                                onChange={e => set({ selectedRegion: e.target.value, selectedProvince: 0 })}>
                                <option value="0">{selectedCountry == 0 ? '— เลือกประเทศก่อน —' : '-- ทั้งหมด --'}</option>
                                {regionOptions.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <label><i className="fas fa-map"></i> จังหวัด</label>
                            <select className="form-select w-100" value={selectedProvince}
                                disabled={selectedCountry == 0}
                                onChange={e => set({ selectedProvince: e.target.value })}>
                                <option value="0">{selectedCountry == 0 ? '— เลือกประเทศก่อน —' : '-- ทั้งหมด --'}</option>
                                {provinceOptions.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                            </select>
                        </div>
                    </div>

                    <hr style={{ margin:'20px 0', borderColor:'#eee' }} />

                    <div style={{ fontSize:12, fontWeight:700, color:'#888', letterSpacing:1, textTransform:'uppercase', marginBottom:10 }}>
                        <i className="fas fa-search" style={{ color:'#dc3545', marginRight:6 }}></i> คำค้นและแท็ก
                    </div>
                    <div className="row g-3">
                        <div className="col-md-9">
                            <label><i className="fas fa-search"></i> คำค้น (รหัส / ชื่อ / สถานที่)</label>
                            <div className="input-group w-100">
                                <span className="input-group-text"><i className="fas fa-search"></i></span>
                                <input type="text" className="form-control" placeholder="พิมพ์คำค้น..."
                                    value={keyword||''} onChange={e => set({ keyword: e.target.value })} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <label><i className="fas fa-hashtag"></i> Hashtag <span style={{ fontWeight:400, fontSize:11, color:'#999' }}>(Enter)</span></label>
                            <div className="input-group w-100">
                                <span className="input-group-text"><i className="fas fa-hashtag"></i></span>
                                <input type="text" className="form-control" placeholder="พิมพ์แล้วกด Enter"
                                    value={hashtagInput||''}
                                    onChange={e => set({ hashtagInput: e.target.value })}
                                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addHashtag(); } }} />
                                <button className="btn btn-outline-danger" style={{ borderRadius:'0 8px 8px 0' }} onClick={addHashtag}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        {(hashtags||[]).length > 0 && (
                            <div className="col-12" style={{ marginTop:20 }}>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap:8 }}>
                                    <span style={{ fontSize:12, color:'#888', marginRight:4 }}>Tag ที่เลือก:</span>
                                    {hashtags.map((h, i) => (
                                        <span key={i} style={{ background:'#dc3545', color:'#fff', padding:'5px 14px', borderRadius:20, fontSize:12, display:'inline-flex', alignItems:'center', gap:6 }}>
                                            #{h}
                                            <i className="fas fa-times" style={{ cursor:'pointer', fontSize:10 }} onClick={() => removeHashtag(i)}></i>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="d-flex justify-content-end mt-3" style={{ gap:8 }}>
                        <button className="btn btn-outline-secondary" style={{ height:40, borderRadius:8, fontSize:14, minWidth:140 }} onClick={clearFilters}>
                            <i className="fas fa-times"></i> ล้างตัวกรอง
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
